import React, { useState } from 'react';
import './StudentsPage.css';

const StudentsPage = () => {
  const [activeStream, setActiveStream] = useState('engineering');

  const streams = {
    engineering: {
      name: 'Engineering & Technology',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      ),
      exams: ['JEE Main', 'JEE Advanced', 'BITSAT', 'VITEEE', 'KCET', 'COMEDK'],
    },
    medical: {
      name: 'Medical & Health Sciences',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      ),
      exams: ['NEET-UG', 'AIIMS', 'JIPMER', 'State PMTs'],
    },
    commerce: {
      name: 'Commerce & Management',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
      ),
      exams: ['CUET', 'IPMAT', 'NPAT', 'SET', 'Christ University'],
    },
    law: {
      name: 'Law',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 3v18M3 12l9-9 9 9M3 12l9 9 9-9" />
        </svg>
      ),
      exams: ['CLAT', 'AILET', 'LSAT India', 'MH CET Law'],
    },
    architecture: {
      name: 'Architecture & Design',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="9" y1="21" x2="9" y2="9" />
        </svg>
      ),
      exams: ['NATA', 'JEE Main Paper 2', 'CEED', 'NID DAT'],
    },
    arts: {
      name: 'Arts & Humanities',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 19l7-7 3 3-7 7-3-3z" />
          <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
          <path d="M2 2l7.586 7.586" />
          <circle cx="11" cy="11" r="2" />
        </svg>
      ),
      exams: ['CUET', 'DU JAT', 'IPU CET', 'BHU UET'],
    },
  };

  return (
    <div className="students-page">
      {/* Hero Section */}
      <section className="students-hero">
        <div className="container">
          <div className="students-hero-grid">
            <div className="students-hero-content">
              <span className="hero-badge">For Students & Parents</span>
              <h1 className="students-hero-title">
                Your Complete <span className="highlight">Career Guidance</span> Companion
              </h1>
              <p className="students-hero-subtitle">
                From exploring careers to planning entrance exams, from discovering colleges to understanding finances—everything you need for a confident post-Class 12 decision.
              </p>
              <div className="students-hero-cta">
                <a href="https://12thplus.com/app/login" className="btn btn-primary">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8" />
                    <path d="M21 21l-4.35-4.35" />
                  </svg>
                  Explore Careers
                </a>
                <a href="https://12thplus.com/app/login" className="btn btn-secondary">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                  View Exam Calendar
                </a>
              </div>
              <div className="trust-badge">
                <div className="trust-avatars">
                  <span className="avatar blue"></span>
                  <span className="avatar teal"></span>
                  <span className="avatar green"></span>
                  <span className="avatar yellow"></span>
                </div>
                <div className="trust-text">
                  <strong>Trusted by 10,000+ Students</strong>
                  <span>Making informed career decisions</span>
                </div>
              </div>
            </div>
            <div className="students-hero-image">
              <img src="/student_banner.png" alt="Students exploring careers" />
            </div>
          </div>
        </div>
      </section>

      {/* Everything You Need Section */}
      <section className="section everything-section">
        <div className="container">
          <h2 className="section-title">Everything You Need in One Place</h2>
          <p className="section-subtitle">
            No more scattered information. Get comprehensive, verified guidance across all aspects of your career journey.
          </p>

          <div className="feature-cards-grid">
            <div className="feature-card">
              <div className="feature-icon teal">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5" />
                  <path d="M2 12l10 5 10-5" />
                </svg>
              </div>
              <h3>Career & Course Intelligence</h3>
              <p>Explore 100+ courses across streams. Understand academic progression, industry outcomes, and career stability.</p>
              <div className="feature-checks">
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Step-by-step pathways</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Industry insights</span>
                </div>
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Salary indicators</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Growth potential</span>
                </div>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-icon blue">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
              </div>
              <h3>College Discovery & Comparison</h3>
              <p>Research Indian colleges and international universities with verified, neutral information.</p>
              <div className="feature-checks">
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Fee structures</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Course comparisons</span>
                </div>
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Placement data</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Campus insights</span>
                </div>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-icon orange">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>
              <h3>Entrance Exam Tracker</h3>
              <p>Never miss an important date. Track all major entrance exams with detailed information.</p>
              <div className="feature-checks">
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Exam patterns</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Eligibility criteria</span>
                </div>
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Important dates</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Preparation tips</span>
                </div>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-icon green">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
              </div>
              <h3>Financial Planning</h3>
              <p>Plan your education finances early with loan insights and fee awareness.</p>
              <div className="feature-checks">
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Loan options</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> EMI calculators</span>
                </div>
                <div className="check-row">
                  <span className="check-item"><span className="check-icon">&#10003;</span> Scholarship info</span>
                  <span className="check-item"><span className="check-icon">&#10003;</span> Budget planning</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Explore by Academic Stream */}
      <section className="section streams-section">
        <div className="container">
          <h2 className="section-title">Explore by <span className="highlight">Academic Stream</span></h2>
          <p className="section-subtitle">
            Comprehensive coverage of all major streams with entrance exams, colleges, and career outcomes.
          </p>

          <div className="streams-explorer">
            <div className="streams-sidebar">
              {Object.entries(streams).map(([key, stream]) => (
                <button
                  key={key}
                  className={`stream-tab ${activeStream === key ? 'active' : ''}`}
                  onClick={() => setActiveStream(key)}
                >
                  <span className="stream-tab-icon">{stream.icon}</span>
                  <span>{stream.name}</span>
                  <svg className="chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ))}
            </div>

            <div className="stream-content">
              <h3>{streams[activeStream].name}</h3>
              <p className="stream-label">ENTRANCE EXAMS COVERED</p>
              <div className="exam-tags">
                {streams[activeStream].exams.map((exam, index) => (
                  <span key={index} className="exam-tag">{exam}</span>
                ))}
              </div>

              <div className="stream-info-grid">
                <div className="stream-info-card">
                  <div className="stream-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4" />
                      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                    </svg>
                  </div>
                  <h4>Exam Information</h4>
                  <ul>
                    <li>Eligibility & attempt limits</li>
                    <li>Exam pattern & scoring</li>
                    <li>Important dates & deadlines</li>
                  </ul>
                </div>

                <div className="stream-info-card">
                  <div className="stream-info-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                  </div>
                  <h4>College Insights</h4>
                  <ul>
                    <li>Colleges accepting each exam</li>
                    <li>Counselling process</li>
                    <li>Seat allocation details</li>
                  </ul>
                </div>
              </div>

              <a href="https://12thplus.com/app/login" className="btn btn-primary stream-cta">
                Explore {streams[activeStream].name}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Your Journey with 12thPlus */}
      <section className="section journey-section">
        <div className="container">
          <h2 className="section-title">Your Journey with <span className="highlight">12thPlus</span></h2>
          <p className="section-subtitle">
            A structured, step-by-step path from exploration to confident decision-making.
          </p>

          <div className="journey-timeline">
            <div className="journey-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Explore Career Options</h3>
                <p>Start from Class 11. Browse 100+ career paths across all streams and understand what each one truly means.</p>
                <div className="step-tags">
                  <span className="step-tag">Career Intelligence</span>
                  <span className="step-tag">Course Pathways</span>
                  <span className="step-tag">Industry Insights</span>
                </div>
              </div>
            </div>

            <div className="journey-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Plan Entrance Exams</h3>
                <p>Track 50+ entrance exams with eligibility, patterns, dates, and preparation tips. Never miss a deadline.</p>
                <div className="step-tags">
                  <span className="step-tag">Exam Calendar</span>
                  <span className="step-tag">Timeline Alerts</span>
                  <span className="step-tag">Application Guide</span>
                </div>
              </div>
            </div>

            <div className="journey-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Discover & Compare Colleges</h3>
                <p>Research 500+ colleges in India and abroad. Compare fees, placements, courses objectively—no paid rankings.</p>
                <div className="step-tags">
                  <span className="step-tag">College Search</span>
                  <span className="step-tag">India & Abroad</span>
                  <span className="step-tag">Verified Info</span>
                </div>
              </div>
            </div>

            <div className="journey-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Financial Planning</h3>
                <p>Understand costs upfront. Explore education loans, scholarships, and budget accordingly with your family.</p>
                <div className="step-tags">
                  <span className="step-tag">Loan Options</span>
                  <span className="step-tag">Scholarships</span>
                  <span className="step-tag">Fee Structures</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Confidence Section */}
      <section className="section confidence-section">
        <div className="container">
          <div className="confidence-card">
            <div className="confidence-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2>Make Your Decision with Confidence</h2>
            <p>Armed with complete information, you choose the right path for YOU—not based on pressure, rumors, or last-minute panic.</p>
          </div>
        </div>
      </section>

      {/* Who Is This Journey For */}
      <section className="section personas-section">
        <div className="container">
          <h2 className="section-title">Who Is This Journey For?</h2>

          <div className="personas-grid">
            <div className="persona-card">
              <div className="persona-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3>Class 11 Students</h3>
              <p>Start exploring academic and career options early</p>
            </div>

            <div className="persona-card">
              <div className="persona-icon teal">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c3 3 9 3 12 0v-5" />
                </svg>
              </div>
              <h3>Class 12 Students</h3>
              <p>Plan entrance exams and college applications strategically</p>
            </div>

            <div className="persona-card">
              <div className="persona-icon orange">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <h3>Parents</h3>
              <p>Get trustworthy, structured guidance for your child</p>
            </div>

            <div className="persona-card">
              <div className="persona-icon green">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                </svg>
              </div>
              <h3>Career Switchers</h3>
              <p>Explore alternative paths and new opportunities</p>
            </div>
          </div>
        </div>
      </section>

      {/* The 12thPlus Difference */}
      <section className="section difference-section">
        <div className="container">
          <h2 className="section-title">The <span className="highlight">12thPlus</span> Difference</h2>
          <p className="section-subtitle">
            See how having structured guidance changes the entire post-Class 12 journey.
          </p>

          <div className="comparison-grid">
            <div className="comparison-card without">
              <div className="comparison-header">Without 12thPlus</div>
              <div className="comparison-items">
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Last-Minute Decisions</h4>
                    <p>Scrambling after results with limited options and time pressure</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Information Overload</h4>
                    <p>Confusing advice from multiple sources, forums, and unverified websites</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Missed Opportunities</h4>
                    <p>Important exam deadlines and application dates slip by unnoticed</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Peer Pressure Choices</h4>
                    <p>Following trends instead of personal aptitude and interests</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Financial Surprises</h4>
                    <p>Unprepared for actual costs, loan options discovered too late</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="x-icon">&#10005;</span>
                  <div>
                    <h4>Unclear Career Path</h4>
                    <p>No understanding of where courses actually lead or job prospects</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="comparison-card with">
              <div className="comparison-header">With 12thPlus</div>
              <div className="comparison-items">
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>Early Planning & Clarity</h4>
                    <p>Start exploring from Class 11, make informed decisions with confidence</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>One Trusted Source</h4>
                    <p>All verified information in one place—careers, exams, colleges, finances</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>Never Miss a Deadline</h4>
                    <p>Centralized exam calendar with alerts for all important dates</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>Personalized Guidance</h4>
                    <p>Explore options based on YOUR interests, not what others are doing</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>Financial Planning Tools</h4>
                    <p>Understand costs upfront, explore loan options and scholarships early</p>
                  </div>
                </div>
                <div className="comparison-item">
                  <span className="check-icon-circle">&#10003;</span>
                  <div>
                    <h4>Career Outcome Clarity</h4>
                    <p>See realistic job prospects, salary ranges, and growth potential</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="section final-cta-section">
        <div className="container">
          <h2>Start Your Career Journey Today</h2>
          <p>Don't wait until after results. Begin exploring, planning, and preparing now for a confident future.</p>
          <div className="cta-buttons">
            <a href="https://12thplus.com/app/login" className="btn btn-primary btn-lg">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
              Explore Careers
            </a>
            <a href="https://12thplus.com/app/login" className="btn btn-secondary btn-lg">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              View Exam Calendar
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudentsPage;
